module.exports = false;



// WEBPACK FOOTER //
// webpack:///node_modules/core-js/modules/_library.js